import { motion, useReducedMotion } from "framer-motion";

export default function SectionShell({ id, eyebrow, title, description, children, className = "" }) {
  const reduceMotion = useReducedMotion();

  return (
    <motion.section
      id={id}
      className={`relative scroll-mt-28 py-20 sm:py-24 ${className}`}
      initial={reduceMotion ? false : { opacity: 0, y: 36 }}
      whileInView={reduceMotion ? {} : { opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
    >
      <div className="mx-auto flex w-full max-w-7xl flex-col gap-10 px-5 sm:px-8 lg:px-10">
        {(eyebrow || title || description) && (
          <div className="max-w-3xl space-y-4">
            {eyebrow && (
              <p
                className="inline-flex rounded-full border border-[#3ABDBC]/35 bg-[#08133E]/80 px-4 py-1 text-xs font-semibold uppercase tracking-[0.24em] text-[#45D6D1] shadow-sm"
                data-testid={`${id}-eyebrow`}
              >
                {eyebrow}
              </p>
            )}
            {title && (
              <h2
                className="max-w-4xl font-display text-4xl font-semibold leading-tight text-white sm:text-5xl"
                data-testid={`${id}-title`}
              >
                {title}
              </h2>
            )}
            {description && (
              <p className="max-w-2xl text-base leading-7 text-[#B8C4DC] sm:text-lg" data-testid={`${id}-description`}>
                {description}
              </p>
            )}
          </div>
        )}
        {children}
      </div>
    </motion.section>
  );
}